import React, { useEffect } from "react"
import anime from 'animejs'

export default function StickyBanner() {
  useEffect(() => {
    let url = window.location.href
    let regex = /posts\/\d+/
    let postsUrl = regex.test(url)

    let dlBtn = document.querySelector('#fadein-app-dl')

    if (postsUrl) {
      let timerId = null
      
      window.addEventListener('scroll', function(e) {
        clearTimeout(timerId)

        timerId = setTimeout(function() {
          anime.remove('#fadein-app-dl')

          if (window.scrollY > 300) {
            anime({
              targets: '#fadein-app-dl',
              opacity: 1,
              duration: 2000,
              begin: function(anim) {
                dlBtn.style.display = 'block'
              }
            }); 
          } else {
            anime({
              targets: '#fadein-app-dl',
              opacity: 0,
              duration: 2000,
              complete: function(anim) {
                dlBtn.style.display = 'none'
              }
            });
          }
        }, 50)      
      })
    }
  })

  return (
  <>
  <div id="fadein-app-dl">
    <a href="https://laxus.co/app/pc/info/howto" className="link-adjust-dl" data-adjust-ui-specific="ui-footer-list-sticky"><span className="link">アプリで簡単レンタル</span></a>
  </div>
  </>
  )
}

